export default [
  {
    title: 'ryanair_online_verification',
    routeName: 'info-slug',
    slug: {
      da: 'ryanair-verificering',
      no: 'ryanair-verifisering',
      sv: 'ryanair-verifiering-online'
    }
  },
  {
    title: 'explanation_of_travle_document',
    routeName: 'info-slug',
    slug: {
      da: 'forklaring-af-rejsedokument',
      no: 'forklaring-av-reisedokument',
      sv: 'forklaring-av-resedokument'
    }
  },
  {
    title: 'baggage_rules',
    routeName: 'info-slug',
    slug: {
      da: 'bagageregler',
      no: 'bagasjeregler',
      sv: 'regler-for-bagage'
    }
  },
  {
    title: 'booking_and_payment',
    routeName: 'info-slug',
    slug: {
      da: 'booking-betaling',
      no: 'bestillingsbetaling',
      sv: 'betalning-for-bokning'
    }
  },
  {
    title: 'passport_and_visa',
    routeName: 'info-slug',
    slug: {
      da: 'pas-visum',
      no: 'pas-visum',
      sv: 'pass-visum'
    }
  },
  {
    title: 'faq',
    routeName: 'info-slug',
    slug: {
      da: 'faq',
      no: 'faq',
      sv: 'faq'
    }
  },
  {
    title: 'about_us',
    routeName: 'info-slug',
    slug: {
      da: 'om-os',
      no: 'om-os',
      sv: 'om-oss'
    }
  },
  {
    title: 'why_choose_us',
    routeName: 'info-slug',
    slug: {
      da: 'hvorfor-vaelge-os',
      no: 'hvorfor-velge-os',
      sv: 'varfor-valja-oss'
    }
  },
  {
    title: 'gift_card',
    routeName: 'gift-card',
    slug: null
  },
  {
    title: 'general_terms_and_conditions',
    routeName: 'info-slug',
    slug: {
      da: 'generelle-betingelser',
      no: 'generelle-betingelser',
      sv: 'generelle-betingelser'
    }
  },
  {
    title: 'guarantee_and_insurances',
    routeName: 'info-slug',
    slug: {
      da: 'garantier-forsikringer',
      no: 'garantier-forsikringer',
      sv: 'garantier-och-forsakringar'
    }
  }
]
